import { RobotProblem } from './robot.types';

type RobotDocs = Record<
    string,
    {
        text: string;
        help: string;
    }
>;

export const PYROBO_DOCS: RobotDocs = {
    move_left: {
        text: 'move_left()',
        help: 'robot.docs.move_left',
    },
    move_right: {
        text: 'move_right()',
        help: 'robot.docs.move_right',
    },
    move_up: {
        text: 'move_up()',
        help: 'robot.docs.move_up',
    },
    move_down: {
        text: 'move_down()',
        help: 'robot.docs.move_down',
    },
    fill_cell: {
        text: 'fill_cell()',
        help: 'robot.docs.fill_cell',
    },
    free_from_up: {
        text: 'free_from_up()',
        help: 'robot.docs.free_from_up',
    },
    free_from_down: {
        text: 'free_from_down()',
        help: 'robot.docs.free_from_down',
    },
    free_from_left: {
        text: 'free_from_left()',
        help: 'robot.docs.free_from_left',
    },
    free_from_right: {
        text: 'free_from_right()',
        help: 'robot.docs.free_from_right',
    },
    wall_from_up: {
        text: 'wall_from_up()',
        help: 'robot.docs.wall_from_up',
    },
    wall_from_down: {
        text: 'wall_from_down()',
        help: 'robot.docs.wall_from_down',
    },
    wall_from_left: {
        text: 'wall_from_left()',
        help: 'robot.docs.wall_from_left',
    },
    wall_from_right: {
        text: 'wall_from_right()',
        help: 'robot.docs.wall_from_right',
    },
    cell_is_filled: {
        text: 'cell_is_filled()',
        help: 'robot.docs.cell_is_filled',
    },
    cell_is_clean: {
        text: 'cell_is_clean()',
        help: 'robot.docs.cell_is_clean',
    },
    color_of_cell: {
        text: 'color_of_cell()',
        help: 'robot.docs.color_of_cell',
    },
    rad_of_cell: {
        text: 'rad_of_cell()',
        help: 'robot.docs.rad_of_cell',
    },
    temp_of_cell: {
        text: 'temp_of_cell()',
        help: 'robot.docs.temp_of_cell',
    },
};

export function filterDocs(functionHints: RobotProblem['markup']['options']['function_hints']): RobotDocs {
    if (!functionHints) {
        return PYROBO_DOCS;
    }

    const docs: RobotDocs = {};

    for (const key in PYROBO_DOCS) {
        if (functionHints.includes(key)) {
            docs[key] = PYROBO_DOCS[key];
        }
    }

    return docs;
}
